import React from 'react'
import PropTypes from 'prop-types'
import { ReactProvider, ReduxProvider } from './providers'

export default function Root({ children, onLoad }) {
  return (
    <ReduxProvider>
      {children}
      <ReactProvider onLoad={onLoad} />
    </ReduxProvider>
  )
}

Root.propTypes = {
  children: PropTypes.node,
  onLoad: PropTypes.func
}
